<template>
    <v-container grid-list-md>
        <v-layout row align-center justify-center mt-4 v-if="loading">
            <tile :loading="true" color="primary"></tile>
        </v-layout>

        <form v-on:submit.prevent="update" v-if="! loading">

            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.name"
                            :error-messages="errors.collect('data.name')"
                            label="Name"
                            data-vv-name="data.name"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-btn large color="primary" class="text--white" type="submit">Save</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    export default {
        props: ['id'],
        data : function() {
            return {
                data : {
                    name: ''
                },
                loading: true,
                error : false,
                message_error : null,
            }
        },
        created: function () {
            this.getFtn();
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods: {
            getFtn() {
                this.$store.dispatch('getLaboratorio', {
                    id: this.id
                }).then((res) => {
                    this.data = res.data;

                    this.loading = false;

                }).catch((error) => {

                });
            },
            update : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('updateLaboratorio', this.data).then((res) => {
                            this.getFtn();

                        }).catch((error) => {
                        });
                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/amcs/view/DataComponent.vue